// extracted by mini-css-extract-plugin
export default {"p":"_6f19305a7e _0d5bdf49a1 _37791787bc","clr":"_29366c7171","dls":"_3e8f7705e0"};